import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaBuilding, FaUserTie, FaEnvelope, FaPhone, FaTimes, FaCheck } from "react-icons/fa";

export default function AddCompanyModal({ isOpen, onClose, onSubmit }) {
  const [newCompany, setNewCompany] = useState({
    name: "",
    owner: "",
    email: "",
    phone: "",
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const err = {};
    if (!newCompany.name.trim()) err.name = "Company name is required";
    if (!newCompany.owner.trim()) err.owner = "Owner name is required";

    if (!newCompany.email.trim()) {
      err.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newCompany.email)) {
      err.email = "Enter a valid email address";
    }

    if (newCompany.phone && !/^\d{7,15}$/.test(newCompany.phone)) {
      err.phone = "Phone must be numbers only (7–15 digits)";
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleAdd = () => {
    if (!validate()) return;
    
    onSubmit(newCompany);
    
    // Clear state after submission
    setNewCompany({ name: "", owner: "", email: "", phone: "" });
    setErrors({});
  };

  const handleClose = () => {
    setNewCompany({ name: "", owner: "", email: "", phone: "" });
    setErrors({});
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal-overlays"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleClose}
        >
          <motion.div
            className="modal-contents"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.7, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 25 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <div>
                <h2>Invite New Company</h2>
                <p>Send an invitation to join your workspace.</p>
              </div>
              <button className="close-btn" onClick={handleClose}>
                <FaTimes size={18} color="#888" />
              </button>
            </div>

            <div className="modal-body">
              {/* Company Name */}
              <div className="input-group">
                <label>
                  <FaBuilding />
                  Company Name
                </label>
                <input
                  type="text"
                  placeholder="e.g. Apex Solutions Pvt Ltd"
                  value={newCompany.name}
                  onChange={(e) =>
                    setNewCompany({ ...newCompany, name: e.target.value })
                  }
                />
                {errors.name && <span className="error">{errors.name}</span>}
              </div>

              {/* Owner */}
              <div className="input-group">
                <label>
                  <FaUserTie /> Owner Name
                </label>
                <input
                  type="text"
                  placeholder="e.g. John Doe"
                  value={newCompany.owner}
                  onChange={(e) =>
                    setNewCompany({ ...newCompany, owner: e.target.value })
                  }
                />
                {errors.owner && (
                  <span className="error">{errors.owner}</span>
                )}
              </div>

              {/* Email */}
              <div className="input-group">
                <label>
                  <FaEnvelope /> Email ID
                </label>
                <input
                  type="email"
                  placeholder="e.g. johndoe@example.com"
                  value={newCompany.email}
                  onChange={(e) =>
                    setNewCompany({ ...newCompany, email: e.target.value })
                  }
                />
                {errors.email && (
                  <span className="error">{errors.email}</span>
                )}
              </div>

              {/* Phone */}
              <div className="input-group">
                <label>
                  <FaPhone /> Phone Number (optional)
                </label>
                <input
                  type="text"
                  placeholder="e.g. 9876543210"
                  value={newCompany.phone}
                  onChange={(e) =>
                    setNewCompany({ ...newCompany, phone: e.target.value })
                  }
                />
                {errors.phone && (
                  <span className="error">{errors.phone}</span>
                )}
              </div>
            </div>

            <div className="modal-actions">
              <button className="btn-secondary" onClick={handleClose}>
                Cancel
              </button>
              <button className="btn-primary" onClick={handleAdd}>
                <FaCheck style={{ marginRight: 6 }} /> Create Company
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
